module.exports = __webpack_public_path__ + "static/media/feather.4ee6796c.svg";